
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";
import ReportService from "../../../services/report-service/ReportService";
import moment from "moment";
import Utili from "../../../utility/Utility";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

function OwwllEarnings(props: any) {
  const getInitialDate = (days: number) => {
    const newDt = new Date();
    newDt.setDate(newDt.getDate() + days);
    return moment(newDt).format("YYYY-MM-DD");
  };

  const classes = useStyles();

  const [selectedToDate, setSelectedToDate] = useState(getInitialDate(0));
  const [selectedFromDate, setSelectedFromDate] = useState(getInitialDate(-30));
  const [maxDate, setMaxToDate] = useState(getInitialDate(0)); // used as InputProps max
  const [validationMessage, setValidationMessage] = useState("");
  const [isValidate, setIsValidate] = useState(false);
  const [reportData, setReportData] = useState("");
  const [pdfBytes, setPdfBytes] = useState("");
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);

  // NEW: status state for radio buttons ("all" | "calls" | "messages")
  const [status, setStatus] = useState<"all" | "calls" | "messages">("all");

  useEffect(() => {
    // Optionally auto-load:
    // getRevenue();
  }, []);

  const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFromDate(e.target.value);
  };

  const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedToDate(e.target.value);
  };

  // NEW: radio change handler
  const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value.toLowerCase();
    // normalize to "all" | "calls" | "messages"
    if (v === "all" || v === "calls" || v === "messages") {
      setStatus(v as "all" | "calls" | "messages");
    }
  };

  const CurrentDate = () => {
    const currDate = new Date();
    return new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate());
  };

  const parseDate = (dt: Date) => {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  };

  const getDateFromString = (date: string) => {
    return new Date(date);
  };

  const getRevenue = () => {
    // Consolidated validation:
    const from = parseDate(getDateFromString(selectedFromDate));
    const to = parseDate(getDateFromString(selectedToDate));
    const today = CurrentDate();

    if (from > to) {
      setIsValidate(true);
      setValidationMessage("From Date cannot be greater than To Date");
      return;
    }

    if (from > today || to > today) {
      setIsValidate(true);
      setValidationMessage("From Date and To Date cannot be in future");
      return;
    }

    setIsValidate(false);
    setValidationMessage("");

    // Build dates; keep "0001-01-01" sentinel when invalid
    const frmDate = selectedFromDate;
    const toDateEndOfDay = moment(selectedToDate + " 23:59:59").format("MM/DD/YYYY hh:mm:ss A");

    const fromParam = frmDate === "Invalid date" ? "0001-01-01" : frmDate;
    const toParam = toDateEndOfDay === "Invalid date" ? "0001-01-01" : toDateEndOfDay;

    // Map UI "status" to backend "type"
    // Backend expects: "all" (ignore type), "call", "message"
    const typeParam =
      status === "all" ? "all" : status === "calls" ? "call" : "message";

    ReportService.getEarningsReport(fromParam, toParam, typeParam).then((res: any) => {
      setReportData(res.data.result.reportHTML);
      setPdfBytes(res.data.result.reportBytes);
      setShowDownloadBtn(true);
    });
  };

  const ClearSearchCriteria = () => {
    setSelectedToDate(getInitialDate(0));
    setSelectedFromDate(getInitialDate(-30));
    setStatus("all"); // reset filter to All
    setIsValidate(false);
    setValidationMessage("");
    setShowDownloadBtn(false);
    setReportData("");
    setPdfBytes("");
  };

  const Download = () => {
    const blob = Utili.b64toBlob(pdfBytes);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "OwwllEarnings";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="col-10 mt-4">
      <h3>Owwll Earnings</h3>
      <div className="pt-2">
        <form className={classes.container} noValidate style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <TextField
              id="dateFrom"
              label="From Date"
              type="date"
              value={selectedFromDate}
              onChange={handleFromDateChange}
              InputProps={{ inputProps: { max: selectedToDate } }}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              id="dateTo"
              label="To Date"
              type="date"
              value={selectedToDate}
              onChange={handleToDateChange}
              InputProps={{ inputProps: { max: maxDate } }}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          {/* Radio group */}
          <div className="form-group mb-2">
            <div className="p-2">
              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="All"
                  id="all"
                  name="status"
                  className="custom-control-input"
                  checked={status === "all"}
                  onChange={handleStatusChange}
                />
                <label className="custom-control-label" htmlFor="all">
                  All
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="Calls"
                  id="calls"
                  name="status"
                  className="custom-control-input"
                  checked={status === "calls"}
                  onChange={handleStatusChange}
                />
                <label className="custom-control-label" htmlFor="calls">
                  Calls
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="Messages"
                  id="messages"
                  name="status"
                  className="custom-control-input"
                  checked={status === "messages"}
                  onChange={handleStatusChange}
                />
                <label className="custom-control-label" htmlFor="messages">
                  Messages
                </label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <button
                  color="secondary"
                  onClick={ClearSearchCriteria}
                  type="button"
                  className="btn btn-sm float-right search-btn stnd-btn view-r-btn"
                >
                  Reset
                </button>
                <button
                  color="secondary"
                  onClick={getRevenue}
                  type="button"
                  className="btn btn-sm float-right search-btn stnd-btn view-r-btn"
                >
                  View Report
                </button>

                {isValidate && (
                  <span className="error-msg" style={{ color: "#ff0000" }}>
                    {validationMessage}
                  </span>
                )}
              </div>
            </div>
          </div>
        </form>

        <div className="mt-4">
          <div className="mb-0 heading">
            <h5>
              Report{" "}
              {showDownloadBtn ? (
                <button
                  color="secondary"
                  onClick={Download}
                  type="button"
                  className="btn btn-sm btn-outline-secondary float-right"
                >
                  Save as
                </button>
              ) : (
                ""
              )}
            </h5>
          </div>
          <div className="report-view-bx">
            <div dangerouslySetInnerHTML={{ __html: reportData }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OwwllEarnings;
